import React, { useState, useRef } from "react";

export default function Tooltip({ children, text }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  return (
    <span
      ref={ref}
      style={{ position: "relative", display: "inline-flex" }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <span
          style={{
            position: "absolute",
            bottom: "calc(100% + 6px)",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#1F2937",
            color: "#F9FAFB",
            fontSize: 11,
            fontWeight: 400,
            padding: "5px 9px",
            borderRadius: 6,
            whiteSpace: "nowrap",
            zIndex: 999,
            pointerEvents: "none",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
        >
          {text}
          <span
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              borderWidth: 4,
              borderStyle: "solid",
              borderColor: "#1F2937 transparent transparent transparent",
            }}
          />
        </span>
      )}
    </span>
  );
}
